import { observable, computed, action } from "mobx";
import {PATH_PAGAMENTO} from '../config/portale-config'

class HomeStore {

  constructor(rootStore) {
    this.rootStore = rootStore
    this.service = rootStore.service
  }

  @observable dettaglioPagamento = {}
  
 
  @observable menuItems = []
  @observable fetched = false
  @observable info = {}
  

  @action
  fetchData() {
    if (!this.fetched) {
      let pagamentoPromise = this.service.doAjax('GET', PATH_PAGAMENTO)

      //Ricarico lo userinfo Store se cambiata l'utenza di lavoro
      this.rootStore.userInfoStore.fetchUserInfo();

      this.rootStore.uiStore.isLoading = true
      Promise.all([pagamentoPromise])
        .then(([pagamento]) => {

          if (pagamento.success)
            this.dettaglioPagamento = pagamento.result

          this.rootStore.uiStore.isLoading = false
          this.fetched = true

        })
    }
  }


}

export default HomeStore;